export default {
    init() {
        this.bindEvents();
    },
    bindEvents() {
        $('.gpi-review .legal-toggle').on('click', (e) => {
            const el = $(e.currentTarget);
            el.toggleClass('active');
            el.parents('.review-footer').find('.footer-legal').slideToggle();
            el.parents('.gpi-review-wrapper').find('.legal-spacer').slideToggle();
        });
    },
};